export const storyKeys = {
  all: ['stories'] as const,
  lists: () => [...storyKeys.all, 'list'] as const,
  list: (familyId: string, filters?: { onlyFavorites?: boolean }) =>
    filters?.onlyFavorites
      ? ([...storyKeys.lists(), familyId, 'favorites'] as const)
      : ([...storyKeys.lists(), familyId] as const),
  details: () => [...storyKeys.all, 'detail'] as const,
  detail: (storyId: string) => [...storyKeys.details(), storyId] as const,
  voices: () => [...storyKeys.all, 'voices'] as const,
  customVoices: (familyId: string) => [...storyKeys.all, 'customVoices', familyId] as const,
};
